export const PLP_PRODUCT_CLICKED = 'PLP: Product Clicked';
export const PLP_PRODUCT_ADDED_TO_CART = 'PLP: Product Added To Cart';
export const SLIDER_PRODUCT_CLICKED = 'Slider: Product Clicked';
export const PDP_PRODUCT_ADDED_TO_CART_AFTER_SEARCH = 'PDP: Product Added To Cart After Search';
export const PDP_PRODUCT_ADDED_TO_CART = 'PDP: Product Added To Cart';
export const PRODUCT_VIEWED = 'Product Viewed';
export const PDP_VIEWED = 'Product Details Page Viewed';
export const PDP_VIEWED_AFTER_SEARCH = 'Product Details Page Viewed After Search';
export const QUICK_VIEW_PRODUCT_ADDED_TO_CART = 'Quickview: Product Added To Cart';
export const QUICK_VIEW_PRODUCT_ADDED_TO_CART_AFTER_SEARCH = 'Quickview: Product Added To Cart After Search';
export const AUTOCOMPLETE_PRODUCT_CLICKED = 'Autocomplete: Product Clicked';
export const FILTER_APPLIED = 'Filter Applied';
export const PRESSED_ENTER = 'Enter';
export const PRESSED_ESCAPE = 'Escape';
export const PRESSED_SPACE = ' ';
export const DEFAULT_LOCALE = 'English';
export const DARK = 'dark';
export const LIGHT = 'light';
export const STATUS = 'In progress';
export const WEEKS = 'weeks';
export const PERCENTAGE = '%';

// GA4 Ecommerce Events
export const GA4_VIEW_ITEM_LIST = 'view_item_list';
export const GA4_SELECT_ITEM = 'select_item';
export const GA4_VIEW_ITEM = 'view_item';
export const GA4_ADD_TO_CART = 'add_to_cart';
export const GA4_ADD_TO_WISHLIST = 'add_to_wishlist';
export const GA4_REMOVE_FROM_CART = 'remove_from_cart';
export const GA4_VIEW_CART = 'view_cart';
export const GA4_BEGIN_CHECKOUT = 'begin_checkout';
export const GA4_ADD_SHIPPING_INFO = 'add_shipping_info';
export const GA4_ADD_PAYMENT_INFO = 'add_payment_info';
export const GA4_PURCHASE = 'purchase';
export const GA4_VIEW_PROMOTION = 'view_promotion';
export const GA4_SELECT_PROMOTION = 'select_promotion';

// GA4 Standard / Non-Ecommerce Events
export const GA4_MENU_NAVIGATION = 'menu_navigation';
export const GA4_FORM_EVENT = 'form_event';
export const GA4_CTA_CLICK = 'cta_click';
export const GA4_NEWSLETTER_SIGN_UP = 'newsletter_sign_up';
export const GA4_ITEM_REVIEW_SUBMIT = 'item_review_submit';
export const GA4_ITEM_GALLERY_VIEW = 'item_gallery_view';
export const GA4_ITEM_CUSTOMIZE = 'item_customize';
export const GA4_PROJECT_START = 'project_start';
export const GA4_PROJECT_RESUME = 'project_resume';
export const GA4_PROJECT_DELETE = 'project_delete';
export const GA4_PROJECT_SAVE = 'project_save';
export const GA4_PROJECT_ACTION = 'project_action';
export const GA4_ERROR_EVENT = 'error_event';

